export const resources = {
  en: {
    translation: {
      rotationScreen: {
        message:
          'Please rotate your device to portrait mode to view experience',
      },
      registration: {
        productRegistered: 'Product Registered!',
        signedUp: "You're Signed Up!",
        warrantyActivated: 'Warranty Activated!',
        completeProfile: 'Complete Profile',
      },
      socialLogin: {
        withGoogleText: 'with Google',
        continueGoogleButton: 'Continue with Google',
        signinError: 'There was an error. Please try signing in again',
        popupBlockedMessage:
          'was blocked by your browser. Please disable popup blockers or choose the email option to continue.',
        cookiesDisabled:
          'Please enable cookies to continue or try registering with email.',
      },
      purchaseDetails: {
        receiptUploadSuccess: 'Receipt uploaded.',
        receiptUploadError: 'Error uploading receipt',
        noReceiptError: 'Please upload purchase receipt',
        firstnameInputPlaceholder: 'Enter first name...',
        firstnameFilledInputPlaceholder: 'First name',
        lastnameInputPlaceholder: 'Enter last name...',
        lastnameFilledInputPlaceholder: 'Last name',
        phoneNumberInputPlaceholder: 'Enter phone number...',
        phoneNumberFilledInputPlaceholder: 'Phone number',
        serialNumberInputPlaceholder: 'Enter serial number...',
        serialNumberFilledInputPlaceholder: 'Serial number',
        uploadReceiptButtonText: 'Upload Receipt',
        datepickerLabel: 'Purchase date...',
        datepickerFilledLabel: 'Purchase date',
        smsConsentRequired: 'Please check the consent box',
        invalidType: 'Invalid file type. Please upload an image or PDF',
        invalidDate: 'Invalid Date',
        receiptFailedError:
          'One or more of your receipts may not meet the requirements.',
        receiptVerificationFailedError:
          '- Please consider re-uploading a clear, well-lit image of your receipt that includes the relevant line items.',
        autoApprovalRequiredError:
          '- Receipt must contain the product that you scanned.',
      },
      signIn: {
        pageTitle: 'Sign In to Brij',
        pageHeaderTitle: 'Sign In',
        withEmail: ' with Email',
        completeProfile: 'Complete Profile',
        useDifferentOption: 'Use a Different Option',
        continueWithEmail: 'Continue with Email',
        unitTagSignInLink: 'Request Sign In Link',
        checkYourEmail: 'Check your email',
        emailInputPlaceholder: 'Enter email...',
        emailInputFilledPlaceholder: 'Email',
        toastMessages: {
          invalidEmail: 'Please enter a valid email address',
          completeRecaptchaVerification:
            'Please complete Recpatcha Verification',
          cantVerifyLoginDetails: 'Not able to verify the login details',
          emailConsentRequired: 'Please check the consent box',
        },
      },
      firebaseErrors: {
        'auth/invalid-email': 'Please provie a valid email',
        'auth/missing-email': 'Please provie an email',
        'auth/user-not-found': "User doesn't exist",
        'auth/wrong-password': 'Invalid email or password',
        'auth/internal-error': 'Server error occured',
        'auth/popup-closed-by-user':
          'Sign in canceled. Please complete the sign in process or choose email option to continue',
        'auth/cancelled-popup-request':
          'Sign in canceled. Please complete the sign in process or choose email option to continue',
        'auth/invalid-credential-or-provider-id': 'Invalid credentials',
        'auth/unauthorized-domain':
          'You are accessing the website from a non secure domain.',
        'auth/invalid-action-code': 'The code is invalid or expired',
        'auth/popup-blocked':
          'Popup blocked. Please enable popups or choose email option to continue.',
      },
      magicLink: {
        linkSentToastMessage:
          'Welcome back! Check your email for a sign-in link.',
        magicLinkError: 'An error occurred',
        redirecting: 'Redirecting...',
      },
      ageGate: {
        title: 'Confirm your age',
        subtitle: 'Are you 21 or older?',
        confirmationButton: 'YES',
        disapprovalButton: 'NO',
        warningMessage: 'You must be 21+ to view this site!',
      },
      productDetails: {
        viewWarranty: 'View Warranty',
        leadInformation: {
          registeredTo: 'Registered To',
          warranty: 'Warranty',
        },
      },
      digitalHub: {
        searchBarPlaceholder: 'Tap to search...',
        dropdownNoResults: 'No results',
      },
      smsOptIn: {
        receiveMessageButton: 'Text Me',
        sendMessageButton: 'Text Us',
        trySendingAgain: 'Try again',
        sendMeText: 'Send me a text instead',
        sendUsText: 'Send us a text instead',
        phoneNumberInputPlaceholder: 'Enter phone number...',
        consentRequiredError: 'Please check the consent box',
        checkYourPhone: 'Check your phone for a text message',
        messageSentText:
          "A text message was sent to the number provided. Don't see it? ",
        defaultLegalText: `<p>By entering your phone number or by sending us a text message you agree to receive recurring automated promotional and personalized marketing text messages (e.g. special offers) from {{brand_name}} at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. View <a href='https://brij.it/terms' target='_blank'>Terms</a> & <a href='https://brij.it/privacy-center' target='_blank'>Privacy</a>.</p>`,
      },
      personalDetails: {
        firstNameInputPlaceholder: 'First Name',
        lastNameInputPlaceholder: 'Last Name',
        phoneNumberInputPlaceholder: 'Phone Number',
        completeProfile: 'Complete Profile',
        continueButton: 'Continue',
        skip: `I'll do this later`,
      },
      sideMenu: {
        myCart: 'My Cart',
        myProfile: 'My Profile',
        myCollection: 'My Collection',
        visitWebsite: 'Visit Website',
        removeProduct: 'Remove Product',
        signOut: 'Sign Out',
        signIn: 'Sign In',
        signOutToastMessage: 'Logout Successful',
        translate: 'Translate',
        termsAndPrivacy: 'Terms & Privacy',
      },
      profile: {
        pageTitle: 'Profile',
        pageHeaderTitle: 'Profile',
        firstNameInput: 'First Name',
        lastNameInput: 'Last Name',
        emailInput: 'Email',
        phoneNumberInput: 'Phone Number',
        saveChanges: 'Save Changes',
        updateToastMessage: 'Profile Updated',
      },
      collection: {
        pageTitle: 'My Collection',
        collectionPageTitle: 'My Collection',
        emptyCollectionMessage: 'No Products in your Collection',
        scanCodeButton: 'Scan Code',
        scanSuccessMessage: 'Product Scanned',
        scanErrorMessage: 'Scan Error',
        invalidScanMessage: 'Not a valid Brij code',
      },
      termsAndPrivacy: {
        brijLegalName: 'Brij.inc',
        pageHeaderTitle: 'Terms & Privacy',
        pageTitle: 'Terms & Privacy',
        subtitle: 'Terms & Conditions and Privacy Policy',
        questionsAboutData: 'Questions about your data?',
        contactUs: 'Contact Us',
        legalNotice: `Brij Inc. acts as a service provider for {{brand_name}}, facilitating the collection and management of user data, including but not limited to email addresses and phone numbers. This partnership allows {{brand_name}} to utilize the data gathered through Brij Inc.'s platform for purposes specified in their respective privacy policies and terms of service. Brij Inc. is committed to handling this data responsibly and in compliance with all applicable data protection laws, ensuring that user privacy is respected and protected in the course of our collaboration with {{brand_name}}. `,
        legalNoticeMixed: `Please see the respective privacy policies and terms and conditions of both Brij Inc. and {{brand_name}} below for more detailed information.`,
        legalNoticeBrij: `Please see the privacy policiy and terms and conditions of Brij Inc. below for more detailed information.`,
      },
      fourZeroFour: {
        pageTitle: '404 | Not Found',
        message: 'This experience does not exist',
        learnMoreButton: 'Learn about Brij',
        learnMoreLink: 'https://brij.it/',
      },
      header: {
        recommendationsHeading: 'Recommendations',
      },
      drawers: {
        bottomDrawer: {
          multipleRegistrationText:
            'Need to register another product? Tap here',
          callToActionButton: 'Call to Action',
          moreButton: 'More',
        },
        autoDeploy: {
          titles: {
            purchaseScreen: 'Add Purchase Details',
            completeProfileScreen: 'Complete Profile',
          },
        },
        authDrawer: {
          termsAndconditions: {
            part1: 'By registering you agree to email communications from ',
            part2: ' and accept ',
            brijBrand: " Brij's ",
            mulberryAndBrijBrand: " mulberry & Brij's ",
            linkText: 'Terms & Conditions',
            part3: ' For help or questions email ',
            helpEmail: 'support@brij.it',
            unitTagDisclaimer:
              'If you are the owner of this product and are having difficulty signing in, please contact ',
          },
          viewDetails: 'View Details',
          fullTermsLink: 'See full terms',
          emailConsentRequired: 'Please check the consent box',
          successMessage: {
            productRegistered: 'Product Registered!',
            signedUp: "You're Signed Up",
            warrantyActivated: 'Warranty Activated!',
          },
        },
        registrationDrawer: {
          purchaseDetailsHeading: 'Add Purchase Details',
          successDrawer: {
            title: 'Product Registered!',
            description: 'Check your email for details',
          },
        },
        warrantyDrawer: {
          warrantyHeading: 'Warranty Active',
          expiredWarrantyHeading: 'Warranty Expired',
          pendingWarrantyHeading: 'Warranty Pending Review',
          deniedWarrantyHeading: 'Warranty Denied',
          mulberryWarrantyHeading: 'Accident Protection Active',
          expiredMulberryWarrantyHeading: 'Accident Protection Expired',
          lifetimeLabel: 'Lifetime',
          pendingInfoText:
            'Your warranty registration is currently under review. Check back later to view its status.',
          deniedInfoText:
            'Your warranty registration was denied. Please submit a valid dated receipt below and ensure the purchase date matches the date on the receipt.',
          issueDate: 'Start Date',
          expirationDate: 'Expiration Date',
          fullTermsLink: 'See full terms',
          viewDetails: 'View Details',
          detailsModal: {
            activateWarrantyHeading: 'Activate Warranty',
            updateWarrantyHeading: 'Update Details',
            description:
              'To activate your warranty please enter the purchase date and upload a dated receipt.',
            updateDescription:
              'To update your purchase details, please enter the new purchase date and upload a dated receipt.',
            activateButton: 'Activate',
            updateButton: 'Update',
            cancelButton: 'Cancel',
          },
          successDrawer: {
            title: 'Warranty Activated!',
            description: 'Check your email for details',
          },
          mulberryTable: {
            description: {
              explanationText:
                'To extend protection or file a claim, click the account activation link that was sent to your email from Mulberry. You can also reach out to Mulberry support',
              linkText: 'here',
            },
          },
        },
        referralDrawer: {
          copyLinkButton: 'Copy link',
          copyLinkToastMessage: 'Copied to clipboard',
          shareLinkButton: 'Share link',
          shareText: 'Have a look at this product from Brij',
          helpText: 'Have your friend scan this code',
        },
        smsDrawer: {
          signUpButton: 'Sign up for VIP texts',
          subscriptionDisclaimer:
            'By signing up via text, you agree to receive recurring automated personalized and promotional marketing text messages from Canopy at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. Must be a resident of the US and 18 years or older. View Terms and Privacy.',
        },
        shopDrawer: {
          successDrawer: {
            title: 'Order Placed!',
            description: 'Check your email for an order confirmation',
          },
          productDetails: {
            showMore: 'More',
            showLess: 'Less',
          },
          savingBanner: {
            title: "You're saving",
          },
          cartButton: {
            callToAction: 'Add to Cart',
            invalidCombo: 'Out of Stock',
            invalidQuantity: 'Select Quantity',
          },
          checkoutHint: {
            chooseOptions: 'Please choose options',
            comboUnavailable: 'Combination not available',
          },
          recommendations: {
            title: 'Recommendations',
            seeMore: 'See More',
          },
          cartResetNotification: 'A new cart has been created for ',
        },
        cartDrawer: {
          checkoutButton: {
            callToAction: 'Checkout',
          },
          drawerTitle: 'My Cart',
          emptyCartText: 'There are currently no items in your cart',
        },
        discountDrawer: {
          discountCodeHeading: 'Discount Code:',
          copiedToClipboard: 'Discount Code copied to clipboard',
        },
        formDrawer: {
          submit: 'Submit',
          next: 'Next',
          start: 'Start',
          regFormFetchError:
            'Registration form fetch unsuccessful. Please refresh and try again.',
          formCompletetionMessage:
            'Your responses were submitted successfully.',
          formSubmissionError: 'Form submission failed. Please resubmit',
          submissionSuccessful: 'Submission Successful',
          fileUpload: {
            fileName: 'File Name...',
            uploadFileButton: 'Upload Files',
            syncToS3Error: 'File Failed to sync to s3 please upload again.',
            fileSizeError: 'File size exceeds 20MB. Please resubmit.',
            fileLimitError: '5 file limit exceeded. Please resubmit.',
            fileExtensionError: `File extenstion not supported. valid files are .pdf, .jpeg,
              .jpg, heic and .png`,
          },
          textArea: {
            placeHolder: 'Type your answer here...',
          },
          dropDown: {
            selectText: 'Click to select',
          },
        },
      },
    },
  },
};
